import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  IconButton,
  Alert,
  Snackbar,
  useTheme,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "./GoalTableStyles";
import TableCell from "@mui/material/TableCell";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useSnackbar } from "hooks/useSnackbar";
import { useGetGoals } from "hooks/queries/useGetGoals";
import { AuthContext } from "navigation/AuthProvider";
import { GoalActionButton } from "components/ActionButton/GoalActionButton";
import IGoal from "models/Goal";

const GoalsTable: React.FC = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedGoal, setSelectedGoal] = useState<IGoal | null>(null);
  const open = Boolean(anchorEl);
  const { getSnackbarProps } = useSnackbar();

  const { user } = useContext(AuthContext);
  console.log("user",user)

  const { goals, isLoading } = useGetGoals();

  const handleMenuOpen = (e: React.MouseEvent<HTMLButtonElement>, goal: IGoal) => {
    setAnchorEl(e.currentTarget);
    setSelectedGoal(goal);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <TableContainer component={Paper} elevation={3}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>STRATEGIC DOMAIN</StyledTableCell>
              <StyledTableCell align="left">KEY PERFORMANCE AREA</StyledTableCell>
              <StyledTableCell align="left">KEY PERFORMANCE INDICATOR</StyledTableCell>
              <StyledTableCell align="left">ASSIGNEE</StyledTableCell>
              <StyledTableCell align="left">WEIGHT</StyledTableCell>
              <StyledTableCell align="left">ACTION</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <div className="loader">
                <div className="justify-content-center jimu-primary-loading"></div>
              </div>
            ) : (
              <>
                {goals?.map((goal) => (
                  <StyledTableRow key={goal.id}>
                    <StyledTableCell component="th" scope="row">
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "15px",
                          fontWeight: 800,
                          color: theme.palette.primary.main,
                        }}
                      >
                        {goal.key_performance_area.strategic_domain.title}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "15px",
                          color: theme.palette.primary.main,
                        }}
                      >
                        {goal.key_performance_area.title}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: "15px",
                        }}
                      >
                        {goal.title}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="left" sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={user.user.profile_image}
                        alt={`${user.user.first_name} ${user.user.last_name}`}
                      />
                      <Box display="flex" alignItems="center" ml={1}>
                        <Typography variant="h6" fontSize="15px">
                          {user.user.first_name}
                        </Typography>
                        <Typography variant="h6" fontSize="15px" sx={{ ml: 0.5 }}>
                          {user.user.last_name}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align="left">{goal.weight} %</StyledTableCell>
                    <TableCell align="left">
                      <IconButton onClick={(e) => handleMenuOpen(e, goal)}>
                        <MoreHorizIcon
                          sx={{
                            backgroundColor: "#F5F6F9",
                            width: 26,
                            height: 26,
                            borderRadius: "100%",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedGoal && (
        <GoalActionButton
          anchorEl={anchorEl}
          open={open}
          handleClose={handleMenuClose}
          goalData={selectedGoal}
          setGoalData={setSelectedGoal}
        />
      )}
      <Snackbar
        {...getSnackbarProps()}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={4000}
      >
        <Alert {...getSnackbarProps()}>{getSnackbarProps().message}</Alert>
      </Snackbar>
    </>
  );
};

export default GoalsTable;
